import type { baseLocale } from './base';

/** Union of all valid dot-notation translation keys */
export type TranslationKey = keyof typeof baseLocale;

/** Supported platform identifiers */
export type Platform = 'sizzlenz' | 'sizzlecpg';

/** Supported language codes */
export type Language = 'en' | 'mi';

/** Platform override: partial subset of base keys */
export type PlatformOverride = Partial<Record<TranslationKey, string>>;

/** Language override: optional base overrides + optional per-platform overrides */
export type LanguageOverride = {
  base?: PlatformOverride;
  platforms?: Partial<Record<Platform, PlatformOverride>>;
};

export const SUPPORTED_PLATFORMS: readonly Platform[] = ['sizzlenz', 'sizzlecpg'] as const;
export const SUPPORTED_LANGUAGES: readonly Language[] = ['en', 'mi'] as const;
export const DEFAULT_LANGUAGE: Language = 'en';
